import React from 'react';
import { Container, Row, Col, Tab } from 'react-bootstrap';
import ProjectCard from './ProjectCard';
import projImg1 from '../assets/img/atlassin.jpeg';
import projImg2 from '../assets/img/win.JPG';
import projImg3 from '../assets/img/cfg.jpeg';
import colorSharp2 from '../assets/img/color-sharp2.png';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const Workex = () => {
  const workex = [
   
    {
      title: "JP MORGAN CFG HACKATHON",
      description: [
        "National Winners | 22-23rd June 2024 | Hyderabad",
        "Implemented a visual progress tracking system to monitor and showcase project advancements to bridge the gap between CRY (Child Rights and You Organization) frontliners, their managers, and partner NGOs.",
        "Automated Reminder system by setting up CRON jobs to send reminders via email and SMS."
      ],
      imgUrl: projImg3,
      links: "https://drive.google.com/file/d/1cw2Y-GSTGDjJ7aoLzrWZGrJ4fXGDo7rG/view?usp=sharing",
    },
    {
        title: "ATLASSIAN",
        description: [
          "Software Engineering Intern (Remote) | May 2024 - July 2024",
          "Implemented an automated AWS resource termination process, reducing the average deletion time by 80%.",
          "Developed a pipeline script to enhance the deletion process, allowing for execution during staging or deployment phases.",
          "Leveraged AWS APIs to verify IAM roles and remove related AWS resources, boosting efficiency by 85%."
        ],
        imgUrl: projImg1,
        links: "https://drive.google.com/file/d/1NTwO4QmIT9rOslPdE_6eTpNT9Nfi8Bm4/view?usp=sharing",
      },
    {
      title: "CODE WITH CISCO HACKATHON",
      description: [
        "National Winners | 9-10th July 2024 | Bengaluru",
        "Developed a Green Network for Interconnected Cities, saving energy using Dynamic Traffic Routing.",
        "Implemented strategies to save power by shutting down routers when bandwidth requirements were low and rerouting the traffic."
      ],
      imgUrl: projImg2,
      links: "https://drive.google.com/file/d/1lB_Tk6Z7uhtoUXyWJG1yH0NvT5FxTU81/view?usp=sharing",
    }
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Internship and National Hackathon Wins</h2>
                 <br></br><br></br>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {workex.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="Background" />
    </section>
  );
}

export default Workex;
